import React from "react";
import {
  Container,
  Typography,
  Box,
  Paper,
  Divider,
} from "@mui/material";

const Section = ({ title, children }) => (
  <Paper
    elevation={0}
    sx={{
      p: 3,
      mb: 3,
      borderRadius: 3,
      border: "1px solid var(--dk-border, #eee)",
      background: "var(--dk-surface-2, #fafafa)",
    }}
  >
    <Typography variant="h6" fontWeight="bold" gutterBottom>
      {title}
    </Typography>
    <Divider sx={{ mb: 2 }} />
    <Typography variant="body1" color="text.secondary" lineHeight={1.8}>
      {children}
    </Typography>
  </Paper>
);

const PrivacyPolicyDriver = () => {
  return (
    <Box sx={{ background: "var(--dk-surface-2, #f4f6f8)", minHeight: "100vh", py: 6 }}>
      <Container maxWidth="md">
        {/* Header */}
        <Box textAlign="center" mb={5}>
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            Privacy Policy
          </Typography>
          <Typography variant="subtitle1" color="text.secondary">
            Eatzy Driver App
          </Typography>
        </Box>

        {/* Sections */}
        <Section title="Introduction">
          Eatzy Driver App respects your privacy and is committed to protecting
          your personal information.
        </Section>

        <Section title="Information We Collect">
          We may collect:
          <ul>
            <li>Name, phone number, email</li>
            <li>Vehicle details and documents</li>
            <li>Location data (for ride tracking)</li>
            <li>Payment and transaction details</li>
          </ul>
        </Section>

        <Section title="How We Use Your Data">
          Your data is used to:
          <ul>
            <li>Provide ride and delivery services</li>
            <li>Match drivers with customers</li>
            <li>Process payments</li>
            <li>Improve app performance</li>
            <li>Ensure safety and compliance</li>
          </ul>
        </Section>

        <Section title="Location Usage">
          We collect real-time location data to:
          <ul>
            <li>Enable trip tracking</li>
            <li>Calculate distance and fare</li>
            <li>Improve service accuracy</li>
          </ul>
        </Section>

        <Section title="Data Protection">
          We use secure systems to protect your data from unauthorized access.
        </Section>

        <Section title="Data Sharing">
          We may share data with:
          <ul>
            <li>Customers (limited info like name & vehicle)</li>
            <li>Payment partners</li>
            <li>Legal authorities if required</li>
          </ul>
        </Section>

        <Section title="Data Retention">
          Data is stored only as long as necessary. Some data may be retained
          for legal or compliance purposes.
        </Section>

        <Section title="Your Rights">
          You can:
          <ul>
            <li>Access your data</li>
            <li>Request correction</li>
            <li>Request account deletion</li>
          </ul>
        </Section>

        <Section title="Contact Us">
          For any privacy-related concerns, contact:
          <br />
          <strong>support@eatzy.com</strong>
        </Section>

        {/* Footer */}
        <Box textAlign="center" mt={4}>
          <Typography variant="caption" color="text.secondary">
            © {new Date().getFullYear()} Eatzy. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default PrivacyPolicyDriver;